export default "__VITE_ASSET__DLSCOAUS__ 500w";